interface WebServiceSettings {
  exclusion_list?: unknown[]
  use_whitelist?: boolean
  whitelist?: unknown[]
}

interface WebService {
  key?: string
  settings?: WebServiceSettings
}

export interface WebWhitelistState {
  enabled: boolean
  exclusionList: unknown[]
}

export function normalizeWebExclusionValue(value: string): string {
  const trimmedValue = value.trim()
  if (!trimmedValue) return ''

  try {
    const url = new URL(
      /^https?:\/\//i.test(trimmedValue)
        ? trimmedValue
        : `https://${trimmedValue}`
    )
    return `https://${url.hostname.toLowerCase()}`
  } catch {
    return trimmedValue.toLowerCase()
  }
}

export function getUnexcludedWebUrls(
  urls: string[],
  exclusionValues: Iterable<string>
): string[] {
  const normalizedExclusions = new Set(
    Array.from(exclusionValues, normalizeWebExclusionValue).filter(Boolean)
  )

  return urls.filter(
    url => !normalizedExclusions.has(normalizeWebExclusionValue(url))
  )
}

export function getWebWhitelistState(services: unknown): WebWhitelistState {
  if (!Array.isArray(services)) {
    return { enabled: false, exclusionList: [] }
  }

  const webServices = (services as WebService[]).filter(service =>
    ['chrome', 'edge'].includes(String(service.key || '').toLowerCase())
  )
  return {
    enabled: webServices.some(service => {
      const settings = service.settings
      if (!settings || settings.use_whitelist !== true) return false

      const whitelist = settings.whitelist
      if (!Array.isArray(whitelist)) return false

      return whitelist.some(item => {
        if (!item || typeof item !== 'object' || !('website' in item)) {
          return false
        }

        const website = (item as { website?: unknown }).website
        return typeof website === 'string' && website.trim().length > 0
      })
    }),
    exclusionList: webServices.flatMap(
      service => service.settings?.exclusion_list || []
    ),
  }
}
